import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const ZohoChatComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let users = useSelector((state) => state.users);
  let organizationsInfo = useSelector((state) => state.organizationsInfo);

  let userId = users?.userDetails?.userId;
  let orgId = organizationsInfo.selectedOrg
    ? organizationsInfo.selectedOrg.orgId
    : -1;

  const handleAddingRequestParam = () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    const paramOrgId = params.get("orgId");
    const paramUserId = params.get("userId");

    let needsRedirect = false;

    // Check if params are missing or don't match current values
    if (!paramOrgId || (orgId !== -1 && paramOrgId !== orgId.toString())) {
      params.set("orgId", orgId !== -1 ? orgId.toString() : "default-org-id");
      needsRedirect = true;
    }

    if (!paramUserId || (userId && paramUserId !== userId.toString())) {
      params.set("userId", userId ? userId.toString() : "default-user-id");
      needsRedirect = true;
    }

    // Only redirect if we needed to update parameters
    if (needsRedirect) {
      navigate(`${location.pathname}?${params.toString()}${location.hash}`, {
        replace: true, // Prevents adding a new entry to history
      });
    }
  };

  useEffect(() => {
    handleAddingRequestParam();

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zsiqscript";
    script.defer = true;
    script.src = "https://salesiq.zoho.com/widget";

    const zohoScriptContent = `
      var $zoho = $zoho || {};
      $zoho.salesiq = $zoho.salesiq || {
        widgetcode: "siq93a73da27b3244b4a5024cf8af74ebcaa19dcc354843f6c2939b433849e8494d",
        values: {},
        ready: function() {}
      };
    `;

    const inlineScript = document.createElement("script");
    inlineScript.type = "text/javascript";
    inlineScript.innerHTML = zohoScriptContent;

    // Append the inline script first
    document.body.appendChild(inlineScript);
    // Then append the Zoho SalesIQ script
    document.body.appendChild(script);

    // Cleanup script on component unmount
    return () => {
      document.getElementById("zsiqscript")?.remove();
      inlineScript.remove();
    };
  }, [orgId, userId]);

  return <div id="zsiqwidget"></div>;
};

export default ZohoChatComponent;
